
import { useState } from 'react';
import { Property } from '@/types/property';
import MultiPropertyCalendar from './multi-property-calendar/MultiPropertyCalendar';

interface MultiPropertyCalendarProps {
  properties: Property[];
  readOnlyBookings?: boolean;
  isAdminContext?: boolean;
}

const MultiPropertyCalendarWrapper = ({ 
  properties, 
  readOnlyBookings = false,
  isAdminContext = false 
}: MultiPropertyCalendarProps) => {
  console.log('🔧 MultiPropertyCalendarWrapper render:', { 
    isAdminContext,
    propertiesCount: properties.length,
    readOnlyBookings
  });

  // Transform properties to the format expected by the multi-property calendar
  const transformedProperties = properties.map(prop => ({
    id: prop.id,
    title: prop.title,
    shortName: prop.shortName || prop.title
  }));

  return (
    <MultiPropertyCalendar 
      properties={transformedProperties} 
      isAdminContext={isAdminContext}
    />
  );
};

export default MultiPropertyCalendarWrapper;
